import {FbqFunction} from './types';

const fbq: FbqFunction = function () {
    if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
    } else {
        fbq.queue.push(arguments);
    }
};
fbq.loaded = true;
fbq.push = fbq;
fbq.queue = [];
fbq.version = '2.0';

if (!window._fbq) {
    window._fbq = fbq;
}

window.fbq = fbq;

export default fbq;
